import { connect, MapStateToProps } from 'react-redux'
import { Props } from './SaveConfigurationButton'
import { startSaveConfiguration } from '../../redux/actions/app/saveConfiguration.actions'
import configurationIsBuildableSelector from '../../redux/selectors/configuration/configurationIsBuildableSelector'
import brandSelector from '../../redux/selectors/brandSelector'

type StateProps = Pick<Props, 'configurationIsBuildable' | 'brand'>

const mapStateToProps: MapStateToProps<StateProps, {}> = (state): StateProps => ({
    configurationIsBuildable: configurationIsBuildableSelector(state),
    brand: brandSelector(state),
})

type DispatchProps = Pick<Props, 'saveConfiguration'>

const mapDispatchToProps: DispatchProps = {
    saveConfiguration: startSaveConfiguration,
}

export default connect(mapStateToProps, mapDispatchToProps)
